import { EmpresaService } from 'src/app/services/empresa/empresa.service';
import { Empresa } from 'src/app/model/empresa/empresa';
import { SysPesquisaDinamica } from 'src/app/model/system/sysPesquisaDinamica';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SysPesquisaDinamicaService } from 'src/app/services/system/sys-pesquisa-dinamica.service';
import { Component, Injector, OnInit } from '@angular/core';
import { FormGenerico } from '../formgenerico/formgenerico';
import { FormRelatoriosGraficosComponent } from '../formrelatoriosgraficos/formrelatoriosgraficos.component';

@Component({
    selector: 'app-dynamic-form',
    templateUrl: './formrelatoriosdynamic.component.html',
    styleUrls: ['./formrelatoriosdynamic.component.css'],
})
export class FormRelatoriosDynamicComponent extends FormGenerico<SysPesquisaDinamica> implements OnInit {
    fields: { campo: string; tipo: string; valor: any }[] = [];
    empresas: { id: number; nome: string }[] = [];
    empresaField: { campo: string; tipo: string; valor: any } | null = null; // Campo fixo para Empresa
    titulo: string = '';

    campoOriginal: { [campoVisivel: string]: string } = {};

    constructor(
        injectorObj: Injector,
        public api: SysPesquisaDinamicaService,
        public empresaService: EmpresaService,
        public config: DynamicDialogConfig,
        public refDialog: DynamicDialogRef,
    ) {
        super(injectorObj, api);
        this.obj = new SysPesquisaDinamica();
        this.titulo = this.config.data.titulo || 'Relatórios';
    }

    override ngOnInit(): void {
        super.ngOnInit();

        // Pegar os campos enviados pela chamada da tela
        this.fields = this.config.data.fields || [];

        // Mapear campos com prefixo 'int_' para exibição sem o prefixo
        this.fields.forEach((field) => {
            if (field.campo) {
                // Remove o prefixo 'int_' e substitui todos os '_' por espaço
                const campoSemPrefixoESublinhado = field.campo.replace('int_', '').replace(/_/g, ' ');
                this.campoOriginal[campoSemPrefixoESublinhado] = field.campo; // Mapeia o original
                field.campo = campoSemPrefixoESublinhado; // Atualiza o campo para exibição amigável
            }
        });

        // Verificar e adicionar o campo "empresa" caso não exista
        const hasEmpresaField = this.fields.some((field) => field.tipo === 'empresa');
        if (!hasEmpresaField) {
            const novoCampoEmpresa = { campo: 'empresa', tipo: 'empresa', valor: [] };
            this.fields.unshift(novoCampoEmpresa); // Adiciona ao início da lista para garantir que seja o primeiro
        }

        // Inicializar o valor de int_Primeiros como 1, se ele existir e for do tipo number
        ['primeiros', 'CodigoPeca', 'Codigo Conta Pgto'].forEach((campo) => {
            const field = this.fields.find(
                (f) => f.campo.toLowerCase() === campo.toLowerCase() && f.tipo === 'number'
            );
            if (field) {
                field.valor = 1; // Inicializa o campo com 1
            }
        });
        
        // Separar o campo de empresa da lista de campos dinâmicos
        this.empresaField = this.fields.find((field) => field.tipo === 'empresa') || null;
        this.fields = this.fields.filter((field) => field.tipo !== 'empresa'); // Remove o campo empresa dos demais

        const agora = new Date();
        this.fields.forEach((field) => {
            if (field.tipo === 'date' && !field.valor) {
                field.valor = agora;
            }
        });

        // Carregar a lista de empresas
        this.carregarEmpresas();
    }

    carregarEmpresas(): void {
        const idEmpresaAtual = this.auth.empresa.id;

        if (!idEmpresaAtual) {
            console.error('ID da empresa atual não disponível.');
            return;
        }

        this.empresaService.listarEmpresasPorEmpresa(idEmpresaAtual).subscribe(
            (empresas) => {
                // Mapear empresas com ID e Nome concatenado
                this.empresas = empresas.map((empresa) => ({
                    id: empresa.id, // Armazenar o ID da empresa
                    nome: `${empresa.id} - ${empresa.nome}` // Concatenar ID e Nome para exibição no dropdown
                }));

                console.log('Empresas carregadas:', this.empresas);

                // Configurar a empresa logada como selecionada
                if (this.empresaField) {
                    this.empresaField.valor = [idEmpresaAtual]; // Selecionar apenas o ID da empresa atual
                    console.log('ID da empresa logada selecionado:', this.empresaField.valor);
                }
            },
            (error) => console.error('Erro ao carregar empresas:', error)
        );
    }

    enviarDados(): void {
        const empresasSelecionadas: { campo: string; valor: string }[] = [];
        const camposDinamicos: { campo: string; valor: any }[] = [];
        const params: { [key: string]: any } = {};
    
        // Processar empresas selecionadas
        if (this.empresaField && Array.isArray(this.empresaField.valor)) {
            const idsSelecionados = this.empresaField.valor;
    
            const empresasDetalhes = this.empresas.filter((empresa) =>
                idsSelecionados.includes(empresa.id)
            );
    
            empresasDetalhes.forEach((empresa) => {
                empresasSelecionadas.push({
                    campo: 'Empresas',
                    valor: `${empresa.id.toString().padStart(3, '0')}`,
                });
            });
    
            // Adicionar IDs de empresas no objeto params
            params['empresas'] = idsSelecionados;
        }
    
        // Processar outros campos dinâmicos
        this.fields.forEach((field) => {
            if (field.valor) {
                const nomeOriginal = this.campoOriginal[field.campo] || field.campo; // Recupera o nome original
                camposDinamicos.push({
                    campo: nomeOriginal,
                    valor: field.valor,
                });
    
                // Adicionar campo e valor no objeto params
                params[nomeOriginal] = field.valor;
            }
        });
    
/*         console.log('Empresas selecionadas:', empresasSelecionadas);
        console.log('Campos dinâmicos:', camposDinamicos);
        console.log('Parâmetros para consulta:', params); */
    
        // Fazer a consulta via serviço
        const idPesq = this.config.data.relatorioId; // Passar o ID do relatório
        this.api.listCustomDynamic(idPesq, params).subscribe(
            (data) => {
                console.log('Resultado da consulta:', data);
    
                // Chamar o callback para enviar os dados de volta
                if (this.config.data.callback) {
                    this.config.data.callback({
                        empresas: empresasSelecionadas,
                        campos: camposDinamicos,
                        resultados: data, // Passar os resultados da consulta
                    });
                }
    
                // Fechar o diálogo
                this.refDialog.close(this.obj);
            },
            (error) => {
                console.error('Erro ao realizar consulta:', error);
            }
        );
    }    

    dataExtraObj(res: any) {
        throw new Error('Method not implemented.');
    }

    protected onPropertyChange(propName: string, newValue: any): void {}
}

